import { render, staticRenderFns } from "./CourseApplyDialog.vue?vue&type=template&id=6e84da8f&"
import script from "./CourseApplyDialog.vue?vue&type=script&lang=js&"
export * from "./CourseApplyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports